@if (isExperimentActive() && !isRegimenPage()) {
<div class="tw-w-full tw-h-20 tw-flex tw-items-center tw-bg-white tw-border-t tw-border-gray-200">
  @for (btn of navButtons(); track btn.key) {
    <div
      class="tw-w-fit tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-between tw-pb-3"
      rippleEffect="rippleEffect"
      [attr.data-testid]="'nav-' + btn.key.toLowerCase()"
      (callback)="onButtonClick(btn.key)">
      <div class="tw-flex-none tw-w-11 tw-h-1 tw-rounded-br tw-rounded-bl"
           [class.tw-bg-teal-400]="isButtonActive(btn)"
           [class.tw-bg-white]="!isButtonActive(btn)"></div>
      <div class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-gap-0.5">
        <cs-icon class="tw-h-7 tw-w-7"
                 [class.tw-text-gray-500]="!isButtonActive(btn)"
                 [iconName]="isButtonActive(btn) ? btn.activeIcon : btn.icon"></cs-icon>
        <div class="tw-font-body tw-text-200"
             [class.tw-text-gray-500]="!isButtonActive(btn)"
             [class.tw-text-teal-400]="isButtonActive(btn)">
          {{ btn.label }}
        </div>
      </div>
    </div>
  }
</div>
}
